import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Fab, withStyles, Tooltip } from '@material-ui/core'
import { Done } from '@material-ui/icons'
import styles from './styles'
import { addOrUpdateForm, readSignupForm } from 'actions/signupForm'
import { receiveForm } from 'actions/signupForm/addOrEdit'

export default withRouter(
  connect(
    state => ({
      formID: state.signupForm.addOrEdit.formID,
      anyChanged: state.signupForm.addOrEdit.changed.anyChanged,
    }),
    dispatch =>
      bindActionCreators(
        { addOrUpdateForm, receiveForm, readSignupForm },
        dispatch
      )
  )(
    withStyles(styles)(
      ({
        classes,
        addOrUpdateForm,
        receiveForm,
        formID,
        history,
        anyChanged,
        readSignupForm,
      }) => (
        <Tooltip title={formID === 'new' ? 'Create form' : 'Update Form'}>
          <Fab
            disabled={!anyChanged}
            onClick={() => {
              if (formID !== 'new') {
                addOrUpdateForm(formID).then(payload => {
                  if (payload) {
                    receiveForm(payload).then(() =>
                      readSignupForm(formID).then(newPayload =>
                        receiveForm(newPayload)
                      )
                    )
                  }
                })
              } else {
                addOrUpdateForm(formID).then(payload => {
                  if (payload) {
                    history.replace(`/forms/${payload.id}`)
                    receiveForm(payload).then(() =>
                      readSignupForm(payload.id).then(newPayload =>
                        receiveForm(newPayload)
                      )
                    )
                  }
                })
              }
            }}
            color="primary"
            className={classes.fab}
          >
            <Done />
          </Fab>
        </Tooltip>
      )
    )
  )
)
